import React from "react";
import { Grid } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Axios from "axios";
import * as Constants from "../../../consts/Constants.js";
import 'bootstrap/dist/css/bootstrap.css';
import anychart from "anychart";
import DataAgeChart from './DataAgeChart.js'
import AgeChart from './AgeChart.js'
import EducationChart from './EducationChart.js'
import MetaData from './MetaData.js'
import CaptionsFilter from './CaptionsFilter.js'
import ZonedMap from './ZonedMap.js'
const { Component } = React;

export default class LiveStats extends Component {

  constructor(props) {
    super(props);
    this.state = { data: null, filteredData: null, loading: false };
    this.filters = { captions:{}, zoneId: null}
    this.filteredData = null;
    
    this.changeFilter = this.changeFilter.bind(this);
    this.clickZone = this.clickZone.bind(this);
    this.loadData = this.loadData.bind(this);

    anychart.licenseKey('pdts-project-unicen-14846cf5-30ed97ef');
    this.loadData();
  }

  componentDidMount() {
    this.loadData();
    const oneMinute = 60000;
    this.timer = setInterval(() => this.loadData(), oneMinute);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  filter(data, filters) {

    const zoneIds = Object.keys(data.counts);
    const newZones = {};

    console.log(filters);

    zoneIds.forEach((zoneId) => {
      if (filters.zoneId == null || filters.zoneId.toString() === zoneId) {
        console.log("zone " + zoneId)
        const newSegments = [];
        data.counts[zoneId].segments.forEach((segment) => {
          const filteredCaptions = Object.keys(filters.captions);
          let accepted = true;
          filteredCaptions.forEach((caption) => {
            if (filters.captions[caption].length !== 0 && !filters.captions[caption].includes(segment.descriptors[caption]))
              accepted = false;
          });
          if (accepted)
            newSegments.push(segment);
        });

        newZones[zoneId] = { segments: newSegments }
      }
    });

    return {counts: newZones, captions: data.captions};
  }

  calculate(data, filters) {
    return this.filter(data, filters);
  }

  loadData() {
    this.setState({...this.state, loading: true })
    Axios.get(Constants.FINAL_LIVE_MOBILITY_STATS + "?layer=1")
    .then((response) => {
        let data = response.data;
        const filtered = this.filter(data, this.filters);
        this.filteredData = filtered;
        this.update({ ...this.state, loading: false, data: data, filteredData: filtered });
      }
    ).catch((_) => {})
    .then(() => { /*setLoading(false)*/})
  }

  calculateMapData(data) {

    let media = 0;

    const ids = Object.keys(data.counts);
    const size = ids.length - 1;
    let total = 0;

    ids.forEach((zoneId) => {
      const zoneCount = data.counts[zoneId];
      if (zoneCount.id !== -1) {
        zoneCount.segments.forEach((segment) => {
          media += segment.value;
          total += segment.value;
        })
      }
    });

    media /= size;

    let desvio = 0;
    let max = 0;
    ids.forEach((zoneId) => {
      const zoneCount = data.counts[zoneId];
      if (zoneCount.id !== -1) {
        let localCount = 0;
        zoneCount.segments.forEach((segment) => {
          localCount += segment.value;
        })
        desvio += Math.pow((localCount-media),2) / size
        if (zoneCount > max)
          max = zoneCount
      }
    });

    desvio = Math.sqrt(desvio)
    const colorRanges = [Math.max(0, media - (2 * desvio)), media, media + (2 * desvio), Math.max(max, media + (2 * desvio))];

    const zones = [];
    data.zones.forEach((apiZone) => {
      if (apiZone.id !== -1) {

        let count = 0;
        data.counts[apiZone.id].segments.forEach((segment) => {
          count += segment.value;
        })

        const coordinates = [];
        apiZone.area.coordinates.forEach((coordinate) => {
          coordinates.push([coordinate.latitude,coordinate.longitude])
        });
      
        zones.push({ 
          "id": apiZone.id, 
          "name": apiZone.name, 
          "coordinates": coordinates,
          "color": this.calcColor(count,colorRanges),
          "count": count
        });
      }
    });

    return { "zones": zones, "colorRanges": colorRanges, "total": total }
  }

  calcColor(value, colorRanges) {
    if (value < colorRanges[0]) {
        return this.rgbToHex(255, 255, 255)
    } else if (value < colorRanges[1]) {
      return this.rgbToHex(255, 255,  Math.round(((1-((value-colorRanges[0])/(colorRanges[1]-colorRanges[0]))))*255))
    } else if (value < colorRanges[2]) {
        return this.rgbToHex(255, Math.round( (1-((value-colorRanges[1])/(colorRanges[2]-colorRanges[1]))) * 255), 0)
    } else {
        return this.rgbToHex(255, 0, 0)
    }
  }

  rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  changeFilter(captionKey,labelKey,checked) {
    const caption = [];
    if (this.filters.captions[captionKey] != null)
      this.filters.captions[captionKey].forEach((label) => { caption.push(label) });
    const newFilters = { ...this.filters };
    if (checked) {
      caption.push(parseInt(labelKey));
    } else {
      const index = caption.indexOf(parseInt(labelKey));
      if (index > -1)
        caption.splice(index, 1);
    }
    
    newFilters.captions[captionKey] = caption;
    this.filters = newFilters;
    const newFiltered = this.filter(this.state.data, newFilters)
    this.update( {...this.state, filteredData: newFiltered } )
  }

  clickZone(zoneId) {

    let newZoneId = null;
    
    if (this.filters.zoneId !== zoneId)
      newZoneId = zoneId;

    const newFilters = {...this.filters };
    newFilters.zoneId = newZoneId;

    this.filters = newFilters;

    const newFiltered = this.filter(this.state.data, newFilters);
    console.log(newFiltered);
    this.update({...this.state, filteredData: newFiltered})
  }

  update(newState) {
    this.setState({...this.state, data: null})
    this.setState(newState)
  }

  render() {
    return (
      <div style={{height: "100%"}} >
        <Grid container spacing={1} style={{height:"100%"}}>
          <Grid item xs={3} style={{height:"100%"}}>
            <Grid container spacing={1} style={{height:"100%"}}>
              <Grid item xs={12} style={{height:"25%"}} >
                <Card style={{ height: "100%", padding: "15px"}}>
                  <MetaData data={this.state.data} loading={this.state.loading} reload={this.loadData} />
                </Card>
              </Grid>
              <Grid item xs={12} style={{height:"75%"}}>
                <CaptionsFilter 
                  data={ this.state.data != null ? (this.state.data.captions) : null }
                  filters={ this.filters }
                  changeFilter={this.changeFilter} />
              </Grid>
            </Grid>
          </Grid> 
          <Grid item xs={5} style={{height:"100%"}}>
            <Grid container spacing={1} style={{height:"100%"}}>
              <Grid item xs={12} style={{height: "30%"}} >
                <Card style={{height:"100%"}} className="chart-container">
                  <DataAgeChart 
                    containerId="dataAgeChart"
                    data={this.state.data} />
                </Card>
              </Grid>
              <Grid item xs={12} style={{height: "70%"}}>
                <Card style={{height:"100%"}} >
                  <Grid container style={{height: "100%"}}>
                    <ZonedMap 
                      data={this.state.data != null ? this.calculateMapData(this.state.data) : null}
                      center={[Constants.LATITUD_AYACUCHO, Constants.LONGITUD_AYACUCHO]}
                      selectZone={this.clickZone}
                      hihglightZone={this.filters.zoneId}
                    />
                  </Grid>
               </Card>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={4} style={{height:"100%"}}>
            <Grid container spacing={1} style={{height:"100%"}}>
            <Grid item xs={12} style={{height:"100%"}} >
              <Card style={{height:"100%"}} >
                <Grid item xs={12} style={{height:"50%"}} className="chart-container">
                  <EducationChart 
                    containerId="genderEducationChart"
                    data={this.state.filteredData}/>
                </Grid>
                <Grid item xs={12} style={{height:"50%"}} className="chart-container">
                  <AgeChart 
                    containerId="genderAgeChart"
                    data={this.state.filteredData}/>
                </Grid>
              </Card>
            </Grid> 
            </Grid>
          </Grid>
        </Grid>
      </div>)
  }

}
